import { createContext, useContext, type ReactNode } from 'react';
import { useReportObjectPayments } from '../model';

const PaymentReportContext = createContext<ReturnType<typeof useReportObjectPayments> | null>(null);

export const usePaymentReport = () => {
    const context = useContext(PaymentReportContext);
    if (!context) throw new Error('usePaymentReport requires ReportObjectPaymentsProvider');
    return context;
};

const ReportObjectPaymentsProvider = ({ children, objectId }: { children: ReactNode; objectId?: number }) => {
    const report = useReportObjectPayments(objectId);
    return <PaymentReportContext.Provider value={report}>{children}</PaymentReportContext.Provider>;
};

export default ReportObjectPaymentsProvider;
